import "./new-home.scss";
import ReactTooltip from "react-tooltip";
import { sendRequestHashtags } from "hooks/useAxios";
import { BiSearchAlt, BiCategoryAlt } from "react-icons/bi";
import { BsCircleSquare } from "react-icons/bs";
import { MdOutlineCategory } from "react-icons/md";
import Select from "react-select";
import { RiProductHuntLine } from "react-icons/ri";
import { MdOutlineLocationCity } from "react-icons/md";
import { HiUserGroup } from "react-icons/hi";
import Product from "common/product/Product";
// import Products from "./Products/Products";
import { useState, useEffect } from "react";
import { translateToReactSelect } from "utils/helperFunctions";
import sendRequest from "hooks/useAxios";
import toast from "react-hot-toast";
import toastFunction from "utils/toast";
import { Helmet } from "react-helmet";
import SingleProduct from "../../common/product/Product";
import { AiOutlineClose } from "react-icons/ai";
import first from "../../assets/images/qab.jpg";
import second from "../../assets/images/qab-2.jpg";
import third from "../../assets/images/qabgol1.jpg";
import fourth from "../../assets/images/qabgol2.jpg";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
import { useContext } from "react";
import Swal from "sweetalert2";
import { RiFilterLine, RiFilterOffFill } from "react-icons/ri";
import GProducts from "./GroupProduct/Products";
import Loader from "utils/Loader";
import { Prev } from "react-bootstrap/esm/PageItem";
import { RiSearchLine } from "react-icons/ri";
import { MdManageSearch } from "react-icons/md";
import { VscGroupByRefType } from "react-icons/vsc";
import logo from "assets/images/sitelogo.svg";
const NewHome = () => {
  const [loading, setLoading] = useState(false);
  const [hashtagsOption, setHashtagsOption] = useState([]);
  const [productOption, setProductOption] = useState([]);
  const [productOptionScound, setProductOptionScound] = useState([]);

  const [subGroup, setSubGroup] = useState([]);

  const [cityOption, setCityOption] = useState([]);
  const [show, setShow] = useState(false);
  const [showCity, setShowCity] = useState(false);
  const [showMsg, setShowMsg] = useState(false);
  const [userType, setUserType] = useState([
    { value: "1", label: "فروشگاه" },
    { value: "2", label: "مصرف کننده" },
  ]);
  const [cityList, setCityList] = useState([]);
  const [filter, setFilter] = useState({});
  const [validate, setValidate] = useState(true);
  const [data2, setData2] = useState([]);
  const [city, setCity] = useState(false);
  const [status, setStatus] = useState("");
  const [flag, setFlag] = useState(false);
  const [activeTab, setActiveTab] = useState();
  const auth = useContext(WithAuthentication);
  const [isOpenModal, setIsOpenModal] = useState({
    isOpen: false,
  });

  const openModal = () => setIsOpenModal({ isOpen: true });
  // closeModal = () => setOpenModal({ isOpen: false });
  // functions
  const changeHandler = (names, values) => {
    // setFlag(false);
    setFilter({ ...filter, [names]: values });
  };
  // translate hashtag

  const translateHashtags = (arrayValue, reverse) => {
    let after = [];
    if (reverse) {
      // react select to api
      for (let index = 0; index < arrayValue.length; index++) {
        let obj = {};
        if (arrayValue[index].hashtag.id) {
          obj.id = arrayValue[index].hashtag.id;
        } else {
          obj.txt = arrayValue[index].hashtag.label;
          obj.id = arrayValue[index].hashtag.value;
        }

        after.push(obj.id);
      }
    } else {
      // api to react select
      for (let index = 0; index < arrayValue?.length; index++) {
        let obj = {};
        {
          arrayValue[index].hashtag.title
            ? (obj.label = arrayValue[index].hashtag.title)
            : (obj.label = arrayValue[index].hashtag.txt);
        }
        obj.value = arrayValue[index].hashtag.id;

        after.push(obj);
      }
    }
    return after;
  };

  const translateProductToReactSelect = (arrayValue, reverse) => {
    let after = [];
    if (reverse) {
      // react select to api
      for (let index = 0; index < arrayValue.length; index++) {
        let obj = {};
        if (arrayValue[index].id) {
          obj.id = arrayValue[index].id;
        } else {
          obj.txt = arrayValue[index].label;
          obj.id = arrayValue[index].value;
        }

        after.push(obj.id);
      }
    } else {
      // api to react select
      for (let index = 0; index < arrayValue.length; index++) {
        let obj = {};
        {
          arrayValue[index].title
            ? (obj.label = arrayValue[index].title)
            : (obj.label = arrayValue[index].txt);
        }
        obj.value = arrayValue[index].id;

        after.push(obj);
      }
    }
    return after;
  };
  const filterIdToObject = (array, id) => {
    return array.filter((a) => a.value == id);
  };

  const validation = () => {
    let valid = false;
    if (
      (filter.subGroupId &&
        filter.subGroupId != "" &&
        filter.buy &&
        filter.buy != "") ||
      (filter.buy != undefined &&
        filter.cityId &&
        filter.cityId != "" &&
        filter.hashtagId &&
        filter.hashtagId != "" &&
        filter.productId &&
        filter.productId != "")
    ) {
      valid = true;
    }
    return valid;
  };
  const validationScound = () => {
    let valid = false;
    if (
      filter.buy &&
      filter.buy != "" &&
      filter.cityId &&
      filter.cityId != "" &&
      filter.productId &&
      filter.productId != ""
    ) {
      valid = true;
    }
    return valid;
  };
  const filterProduct = () => {
    let isGroup = filter.buy == 1 || filter.buy == "multiple" ? 1 : 0;
    sendRequest("homefilter", { ...filter, isGroup: isGroup }).then(
      ({ data }) => {
        if (data.status == 1) {
          setData2(data.items);
          setStatus(1);
        } else if (data.status == 0) {
          setShow(true);
          setData2([]);
        } else if (data.status == 2) {
          setCity(true);
          const unique = [
            ...new Map(data.items.map((m) => [m.id, m])).values(),
          ];
          setCityOption(translateProductToReactSelect(unique, false));
          setShowCity(true);
        } else if (data.status == 3) {
          setData2(data.items);
          setShowMsg(true);
        } else if (data.status == 4) {
          setData2(data.items);
          setStatus(4);
        } else {
          setShow(true);
          setData2([]);
        }
        setLoading(false);
      }
    );
  };
  // apis
  useEffect(() => {
    setLoading(true);
    async function loadPage() {
      await sendRequestHashtags("get_main_hashtag").then((data) => {
        setHashtagsOption(translateHashtags(data.data.data, false));
        setLoading(false);

        console.log("#", data.data.data[0].hashtag);
      });
      await sendRequest("Find_cities").then((data) => {
        // console.log("city", data.data);
        setCityOption(translateProductToReactSelect(data.data, false));
        setLoading(false);
      });
      await sendRequest("Find_products", {
        conditions: `main_status/=/${0}`,
      }).then((data) => {
        setProductOptionScound(translateProductToReactSelect(data.data, false));
        setLoading(false);
      });
    }
    loadPage();
    console.log("#$$", productOptionScound);
    setCityList((prev) => {
      let temp = [...prev];
      for (let i = 0; i < cityList.length; i++) {
        temp[i] = { ...temp[i], stat: true };
      }
      return temp;
    });
    setFilter((prev) => {
      if (activeTab == 0) {
        return {
          ...prev,

          buy: `${auth.userInfo.userType == 2 ? "multiple" : "single"}`,
        };
      } else if (activeTab == 1) {
        return {
          ...prev,

          buy: `${auth.userInfo.userType == 2 ? 1 : 0}`,
        };
      }
      // return {
      //   ...prev,

      //   // buy: `${auth.userInfo.userType == 2 ? "multiple" : "single"}`,
      //   buy: `${auth.userInfo.userType == 2 ? 1 : 0}`,
      // };
    });
  }, [auth]);

  // consoles
  console.log("filter", filter);
  console.log("authhome : ", auth.userInfo);

  return (
    <div>
      {loading && <Loader />}
      <Helmet>
        <meta charSet="utf-8" />
        <title>{`گروه مارکت`} </title>
        {/* <link rel="canonical" href="http://mysite.com/example" /> */}
      </Helmet>
      <div className="my-4 new-home mx-auto border shadow">
        <nav>
          <div class="nav nav-tabs" id="nav-tab" role="tablist">
            <button
              onClick={() => {
                setFilter({});
                setActiveTab(0);
                setShowCity(false);
              }}
              className="nav-link active"
              id="nav-advance-id"
              data-bs-toggle="tab"
              data-bs-target="#nav-advance-content"
              type="button"
              role="tab"
              aria-controls="nav-advance"
              aria-selected="true"
              style={{ backgroundColor: "#f6f6fe ", border: "none" }}
            >
              جستجو پیشرفته
            </button>
            <button
              className="nav-link"
              id="nav-search-id"
              data-bs-toggle="tab"
              data-bs-target="#nav-search-content"
              type="button"
              role="tab"
              aria-controls="nav-search"
              aria-selected="false"
              onClick={() => {
                setFilter({});
                setActiveTab(1);
                setShowCity(false);
              }}
              style={{ backgroundColor: "aliceblue ", border: "none" }}
            >
              جستجو سریع
            </button>
          </div>
        </nav>
        <div class="tab-content" id="nav-tabContent">
          {/* first tab */}
          <div
            className="tab-pane fade show active "
            style={{ backgroundColor: "#f6f6fe " }}
            id="nav-advance-content"
            role="tabpanel"
            aria-labelledby="nav-advance"
          >
            <div className="d-flex flex-wrap">
              {/* <div className="advance position-relative">
                <div
                  className="position-absolute text-secondary float-label"
                  style={{
                    display:
                      filter.user && (filter.user != "") != ""
                        ? "block"
                        : "none",
                  }}
                >
                  نوع کاربر:
                </div>
                <div className="input-group p-3 h-100 ">
                  <span
                    className="input-group-text icon-container"
                    id="basic-addon1"
                  >
                    <HiUserGroup className="icons" />
                  </span>

                  <Select
                    //   type="text"
                    className="form-control  search-input "
                    placeholder="نوع کاربر را انتخاب کنید..."
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    options={userType}
                    onChange={(e) => {
                      changeHandler("user", e.value);
                      e.value == "1" && changeHandler("buy", "multiple");
                    }}
                    value={filterIdToObject(userType, filter.user)}
                  />
                </div>
              </div> */}
              <div className="advance position-relative">
                <div
                  className="position-absolute text-secondary float-label"
                  style={{
                    display:
                      filter?.hashtagId && (filter?.hashtagId != "") != ""
                        ? "block"
                        : "none",
                  }}
                >
                  گروه کالایی:
                </div>
                <div className="input-group p-3 w-100 h-100 ">
                  <span
                    className="input-group-text icon-container"
                    id="basic-addon1"
                  >
                    <BiCategoryAlt className="icons" />
                  </span>
                  <Select
                    //   type="text"
                    className="form-control  search-input  "
                    placeholder="لطفا گروه کالایی خود را وارد یا انتخاب نمایید."
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    options={hashtagsOption}
                    onChange={(e) => {
                      setLoading(true);
                      changeHandler("hashtagId", e.value);
                      filter?.subGroupId && changeHandler("subGroupId", "");
                      async function loadPage() {
                        await sendRequestHashtags("get_sub_hashtag", {
                          hashtag_id: `${e.value}`,
                          // tbl_name: "Inner Join,hashtags,hashtag_id,id",
                          // conditions: `hashtags_links.parent_id/=/${e.value}  `,
                        }).then((data) => {
                          setSubGroup(
                            translateProductToReactSelect(data.data.data, false)
                          );
                          setLoading(false);
                        });
                      }
                      loadPage();
                    }}
                    value={filterIdToObject(hashtagsOption, filter?.hashtagId)}
                  />
                </div>
              </div>
              <div className="advance position-relative">
                <div
                  className="position-absolute text-secondary float-label"
                  style={{
                    display:
                      filter?.subGroupId && (filter?.subGroupId != "") != ""
                        ? "block"
                        : "none",
                  }}
                >
                  زیرگروه کالایی:
                </div>
                <div className="input-group p-3 w-100 h-100 ">
                  <span
                    className="input-group-text icon-container"
                    id="basic-addon1"
                  >
                    <MdOutlineCategory className="icons" />
                  </span>
                  <Select
                    //   type="text"
                    className="form-control  search-input "
                    placeholder={
                      filter?.hashtagId && filter?.hashtagId != ""
                        ? ` لطفا زیر گروه کالایی خود را وارد یا انتخاب نمایید.`
                        : `هنوز گروه کالایی راانتخاب نکرده اید!!`
                    }
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    options={subGroup}
                    onChange={(e) => {
                      changeHandler("subGroupId", e.value);
                      sendRequest("Find_products_hashtags_links", {
                        tbl_name:
                          "Inner Join,hashtags,hashtag_id,id@@Inner Join,products,product_id,id",
                        conditions: `products_hashtags_links.hashtag_id/=/${e.value}  `,
                        fields: "products.id, products.title",
                      }).then((data) => {
                        setProductOption(
                          translateProductToReactSelect(data.data, false)
                        );
                      });
                      //filter.hashtagId && changeHandler("hashtagId", "");
                    }}
                    value={filterIdToObject(subGroup, filter?.subGroupId)}
                  />
                </div>
              </div>
              <div className="advance position-relative">
                <div
                  className="position-absolute text-secondary float-label"
                  style={{
                    display:
                      filter?.productId && (filter?.productId != "") != ""
                        ? "block"
                        : "none",
                  }}
                >
                  کالا:
                </div>
                <div className="input-group p-3 h-100 ">
                  <span
                    className="input-group-text icon-container"
                    id="basic-addon1"
                  >
                    {/* <RiProductHuntLine className="icons" /> */}
                    <BsCircleSquare
                      className="icons"
                      style={{ width: 15, height: 15 }}
                    />
                  </span>

                  <Select
                    //   type="text"
                    className="form-control  search-input "
                    placeholder={
                      filter?.subGroupId && filter?.subGroupId != ""
                        ? ` لطفا کالای خود را وارد یا انتخاب نمایید.`
                        : `هنوز زیر گروه کالایی خود را انتخاب نکرده اید!!`
                    }
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    options={productOption}
                    onChange={(e) => {
                      changeHandler("productId", e.value);
                      //filter.subGroupId && changeHandler("subGroupId", "");
                    }}
                    value={filterIdToObject(productOption, filter?.productId)}
                  />
                </div>
              </div>

              <div className="advance position-relative">
                <div
                  className="position-absolute text-secondary float-label"
                  style={{
                    display:
                      filter?.cityId && (filter?.cityId != "") != ""
                        ? "block"
                        : "none",
                  }}
                >
                  شهر: {city && "جستجو محدود شده است"}
                </div>
                <div className="input-group p-3 h-100">
                  <span
                    className="input-group-text icon-container"
                    id="basic-addon1"
                  >
                    <MdOutlineLocationCity className="icons" />
                  </span>
                  <Select
                    //   type="text"
                    className="form-control  search-input "
                    placeholder=" شهر محل سکونت را وارد یا انتخاب کنید ..."
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    value={filterIdToObject(cityOption, filter?.cityId)}
                    options={cityOption}
                    onChange={(e) => {
                      changeHandler("cityId", e.value);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-center flex-wrap">
              <div className="advance-radio">
                <div
                  className={`input-group p-3 h-100 ${
                    auth.userInfo.userType == 2 && "disable-buy"
                  }`}
                >
                  <span
                    className="input-group-text icon-container"
                    id="basic-addon1"
                  >
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioDefault"
                      id="flexRadioDefault1"
                      // disabled={filter.user && filter.user == "1" && true}
                      disabled={auth.userInfo.userType == 2 && true}
                      onClick={(e) => {
                        changeHandler("buy", 0);
                      }}
                      checked={filter?.buy == 0}
                    />{" "}
                  </span>
                  <div className=""></div>
                  <div
                    className="form-check-label form-control search-input px-4 py-3 align-items-center"
                    style={{ padding: "12px 8px", textAlign: "center" }}
                    // for="flexRadioDefault1"
                  >
                    {/* first Tab */}
                    <label htmlFor="flexRadioDefault1">خرید تکی</label>
                  </div>
                </div>
              </div>
              <div className="advance-radio">
                <div className="input-group p-3 h-100">
                  <span
                    className="input-group-text icon-container"
                    id="basic-addon1"
                  >
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioDefault"
                      id="flexRadioDefault2"
                      checked={filter?.buy == 1 ? true : false}
                      onChange={(e) => {
                        changeHandler("buy", 1);
                      }}
                    />{" "}
                  </span>
                  <div
                    className="form-check-label form-control search-input  align-items-center px-4 py-3"
                    style={{ padding: "12px 8px", textAlign: "center" }}
                    // for="flexRadioDefault2"
                  >
                    <label htmlFor="flexRadioDefault2"> خرید گروهی </label>
                  </div>
                </div>
              </div>
            </div>
            {showCity && (
              <div className="w-50 mx-3">
                <p className="text-danger d-inline">
                  * در شهر انتخابی شما این محصول وجود ندارد شما{" "}
                  <strong>الان</strong> میتوانید در شهر{" "}
                  <strong>
                    {cityOption.map((item) => `${item.label}` + " ")}
                  </strong>
                  این محصول را انتخاب کنید
                </p>
              </div>
            )}

            <p
              className={`validation-text text-end me-4 ${
                validate == true ? "d-none" : "d-block"
              }`}
            >
              لطفا تمامی فیلدها را انتخاب کنید.
            </p>
            <div className="d-flex justify-content-center pe-3 pb-3">
              {/* <button
                className="btn btn-search px-4 py-2 bg-danger mx-2"
                onClick={() => {
                  setFilter({});
                  setShowCity(false);
                  setShowMsg(false);
                  setData2([]);
                  setCity(false);
                  sendRequest("Find_cities").then((data) => {
                    // console.log("city", data.data);
                    setCityOption(
                      translateProductToReactSelect(data.data, false)
                    );
                  });
                }}
              >
                <RiFilterOffFill className="me-2" />
                حذف فیلتر
              </button> */}
              <div
                className="input-group p-3 w-100 h-100 d-flex justify-content-center "
                style={{ borderRadius: "10px" }}
              >
                <div>
                  <span
                    className="span-del "
                    data-tip="حذف فیلترهای اعمال شده"
                    data-for="gm-tooltip"
                  >
                    <button
                      className="del-filter "
                      onClick={() => {
                        setFilter({});
                        setShowCity(false);
                        setShowMsg(false);
                        setData2([]);
                        setCity(false);
                        sendRequest("Find_cities").then((data) => {
                          // console.log("city", data.data);
                          setCityOption(
                            translateProductToReactSelect(data.data, false)
                          );
                        });
                      }}
                    >
                      <AiOutlineClose className=""></AiOutlineClose>
                    </button>
                  </span>
                  <span className="span-btn-search ">
                    {auth.userInfo.userType == -1 ? (
                      <button
                        data-bs-toggle="modal"
                        data-bs-target="#ModalNumber"
                        className="btn-search px-4 py-3 "
                        onClick={() => {
                          if (auth.userInfo.userType == -1) {
                            toastFunction(
                              "error",
                              "لطفا ابتدا وارد سایت شوید."
                            );
                          } else {
                            if (validation()) {
                              setValidate(true);
                              filterProduct();
                              setShow(false);
                              setShowMsg(false);
                              setShowCity(false);
                              setFlag(true);
                              setLoading(true);
                              filter.buy == "1"
                                ? setFlag(true)
                                : setFlag(false);
                            } else setValidate(false);
                          }
                        }}
                      >
                        <span style={{ marginLeft: "10px" }}>
                          <RiSearchLine className="" />
                        </span>
                        جستجو
                      </button>
                    ) : (
                      <button
                        className="btn-search px-4 py-3 "
                        onClick={() => {
                          if (validation()) {
                            setValidate(true);
                            filterProduct();
                            setShow(false);
                            setShowMsg(false);
                            setShowCity(false);
                            setFlag(true);
                            setLoading(true);
                            filter.buy == "1" ? setFlag(true) : setFlag(false);
                          } else setValidate(false);
                        }}
                      >
                        <span style={{ marginLeft: "10px" }}>
                          <RiSearchLine className="" />
                        </span>
                        جستجو
                      </button>
                    )}
                  </span>
                </div>
              </div>
            </div>
          </div>
          {/* second tab */}
          <div
            className="tab-pane fade "
            style={{ backgroundColor: "aliceblue" }}
            id="nav-search-content"
            role="tabpanel"
            aria-labelledby="nav-search"
          >
            <div className="d-flex justify-content-center flex-wrap">
              <div className="advance position-relative">
                <div className="position-absolute text-secondary float-label">
                  کالا :
                </div>
                <div className="d-flex justify-content-center">
                  <div className="input-group p-3 w-100 h-100 d-flex justify-content-center ">
                    <span
                      className="input-group-text icon-container"
                      id="basic-addon1"
                    >
                      <MdManageSearch className="icons" />
                    </span>
                    <Select
                      //   type="text"
                      className="form-control  search-input  "
                      placeholder=" محصول موردنظر را جستجو کنید..."
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                      options={productOptionScound}
                      onChange={(e) => {
                        changeHandler("productId", e.value);
                      }}
                      value={filterIdToObject(
                        productOptionScound,
                        filter?.productId
                      )}
                    />
                  </div>
                </div>
              </div>
              <div className="advance position-relative">
                <div
                  className="position-absolute text-secondary float-label"
                  // style={{
                  //   display:
                  //     filter.cityId && (filter.cityId != "") != ""
                  //       ? "block"
                  //       : "none",
                  // }}
                >
                  شهر: {city && "جستجو محدود شده است"}
                </div>
                <div className="input-group p-3 h-100">
                  <span
                    className="input-group-text icon-container"
                    id="basic-addon1"
                  >
                    <MdOutlineLocationCity className="icons" />
                  </span>
                  <Select
                    //   type="text"
                    className="form-control  search-input "
                    placeholder=" شهر محل سکونت را وارد یا انتخاب کنید ..."
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    value={filterIdToObject(cityOption, filter?.cityId)}
                    options={cityOption}
                    onChange={(e) => {
                      changeHandler("cityId", e.value);
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-center flex-wrap">
              <div className="advance-radio1">
                <div
                  className={`input-group p-3 h-100 ${
                    auth.userInfo.userType == 2 && "disable-buy"
                  }`}
                >
                  <span
                    className="input-group-text icon-container"
                    id="basic-addon1"
                  >
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioDefault"
                      id="flexRadioDefault4"
                      // disabled={filter.user && filter.user == "1" && true}
                      disabled={auth.userInfo.userType == 2 && true}
                      onClick={(e) => {
                        changeHandler("buy", "single");
                      }}
                      checked={filter?.buy == "single"}
                    />{" "}
                  </span>
                  <div className=""></div>
                  <div
                    className="form-check-label form-control search-input px-4 py-3 align-items-center"
                    style={{ padding: "12px 8px", textAlign: "center" }}
                    // for="flexRadioDefault1"
                  >
                    <label htmlFor="flexRadioDefault4">خرید تکی</label>
                  </div>
                </div>
              </div>
              <div className="advance-radio1">
                <div className="input-group p-3 h-100">
                  <span
                    className="input-group-text icon-container"
                    id="basic-addon1"
                  >
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioDefault"
                      id="flexRadioDefault3"
                      checked={filter?.buy == "multiple"}
                      onClick={(e) => {
                        changeHandler("buy", "multiple");
                      }}
                    />{" "}
                  </span>
                  <div
                    className="form-check-label form-control search-input  align-items-center px-4 py-3"
                    style={{ padding: "12px 8px", textAlign: "center" }}
                    // for="flexRadioDefault2"
                  >
                    <label htmlFor="flexRadioDefault3"> خرید گروهی </label>
                  </div>
                </div>
              </div>
            </div>
            {showCity && (
              <div className="w-50 mx-3">
                <p className="text-danger d-inline">
                  * در شهر انتخابی شما این محصول وجود ندارد شما{" "}
                  <strong>الان</strong> میتوانید در شهر{" "}
                  <strong>
                    {cityOption.map((item) => `${item.label}` + " ")}
                  </strong>
                  این محصول را انتخاب کنید
                </p>
              </div>
            )}
            <div className="d-flex justify-content-center">
              <div
                className="input-group p-3 w-100 h-100 d-flex justify-content-center "
                style={{ borderRadius: "10px" }}
              >
                <div>
                  <span
                    className="span-del "
                    data-tip="حذف فیلترهای اعمال شده"
                    data-for="gm-tooltip"
                  >
                    <button
                      className="del-filter "
                      onClick={() => {
                        setFilter({});
                        setShowCity(false);
                        setShowMsg(false);
                        setData2([]);
                        setCity(false);
                        sendRequest("Find_cities").then((data) => {
                          // console.log("city", data.data);
                          setCityOption(
                            translateProductToReactSelect(data.data, false)
                          );
                        });
                      }}
                    >
                      <AiOutlineClose className=""></AiOutlineClose>
                    </button>
                  </span>
                  <span className="span-btn-search ">
                    {auth.userInfo.userType == -1 ? (
                      <button
                        data-bs-toggle="modal"
                        data-bs-target="#ModalNumber"
                        className="btn-search px-4 py-3 "
                        onClick={() => {
                          if (auth.userInfo.userType == -1) {
                            toastFunction(
                              "error",
                              "لطفا ابتدا وارد سایت شوید."
                            );
                          } else {
                            if (validationScound()) {
                              setValidate(true);
                              filterProduct();
                              setShow(false);
                              setShowMsg(false);
                              setShowCity(false);
                              setFlag(true);
                              setLoading(true);
                              filter?.buy == "multiple"
                                ? setFlag(true)
                                : setFlag(false);
                            } else setValidate(false);
                          }
                        }}
                      >
                        <span style={{ marginLeft: "10px" }}>
                          <RiSearchLine className="" />
                        </span>
                        جستجو
                      </button>
                    ) : (
                      <button
                        className="btn-search px-4 py-3 "
                        onClick={() => {
                          if (validationScound()) {
                            setValidate(true);
                            filterProduct();
                            setShow(false);
                            setShowMsg(false);
                            setShowCity(false);
                            setFlag(true);
                            setLoading(true);
                            filter?.buy == "multiple"
                              ? setFlag(true)
                              : setFlag(false);
                          } else setValidate(false);
                        }}
                      >
                        <span style={{ marginLeft: "10px" }}>
                          <RiSearchLine className="" />
                        </span>
                        جستجو
                      </button>
                    )}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mx-auto txt-h" style={{ width: "fit-content" }}>
        {show && <h1>محصولی یافت نشد</h1>}

        {/* {showMsg && filter.buy == "multiple" ? (
          <h1>شما به محصولات تامین کننده اصلی رسیدید</h1>
        ) : (
          ""
        )} */}
        {showMsg ? (
          flag ? (
            <h3>شما به محصولات تامین کننده اصلی رسیدید</h3>
          ) : (
            <h5>
              متاسفانه محصول تکی یافت نشد شما میتوانید از محصولات تامین کننده
              اصلی خرید گروهی داشته باشید{" "}
            </h5>
          )
        ) : (
          ""
        )}
      </div>
      {
        data2 && (
          // status == 4 ? (
          <div className="w-100 ">
            <GProducts data={data2} />
          </div>
        )
        // ) : (
        //   <div className="d-flex flex-wrap " style={{ width: "fit-content" }}>
        //     {data2.length != 0
        //       ? data2.map((item, index) => (
        //           <SingleProduct
        //             key={index}
        //             data={{
        //               id: item.product_id,
        //               name: item.title,
        //               dis: item.description,
        //               brand: item.brandid,
        //               score_count: item.rating_count,
        //               score: item.avg_rating,
        //               image: item.url.length > 0 ? item.url[0].url : "",
        //               businesses_id: item.businesses_id,
        //               price: item.main_price,
        //               discount: item.main_discount,
        //             }}
        //           />
        //         ))
        //       : ""}
        //   </div>
        // )
      }
    </div>
  );
};

export default NewHome;
